import { scorePrediction } from '../../scoring'
import type { FixtureView } from '../../types'

/** Where a pick stands on a fixture — the four bands the pick line has always used. */
export type PickTier = 'exact' | 'correct' | 'partial' | 'miss'

/**
 * Where the pick stands on this fixture **right now**: judged against the live score while the
 * match is in play, against the final score once it is over. `null` when there is nothing to
 * judge — an upcoming fixture, or one the user never predicted.
 */
export function standingTierFor(view: FixtureView): PickTier | null {
  const score =
    view.status === 'live' ? view.liveScore : view.status === 'final' ? view.finalScore : null
  if (!view.prediction || !score) return null
  const { points } = scorePrediction(view.prediction, score)
  if (points >= 5) return 'exact'
  if (points >= 3) return 'correct'
  if (points >= 1) return 'partial'
  return 'miss'
}
